import axios from 'axios';
import { 
    USER_PERMISSIONS_REQUEST,
    USER_PERMISSIONS_SUCCESS,
    USER_PERMISSIONS_FAILURE,
    ASSIGN_USER_PERMISSIONS_REQUEST,
    ASSIGN_USER_PERMISSIONS_SUCCESS,
    ASSIGN_USER_PERMISSIONS_FAILURE,
    REVOKE_USER_PERMISSIONS_REQUEST,
    REVOKE_USER_PERMISSIONS_SUCCESS,
    REVOKE_USER_PERMISSIONS_FAILURE,
    SYNC_USER_PERMISSIONS_REQUEST,
    SYNC_USER_PERMISSIONS_SUCCESS,
    SYNC_USER_PERMISSIONS_FAILURE,
    AVAILABLE_PERMISSIONS_REQUEST,
    AVAILABLE_PERMISSIONS_SUCCESS,
    AVAILABLE_PERMISSIONS_FAILURE,
    CLEAR_USER_PERMISSIONS_STATE
} from './types';

// Get user permissions breakdown
export const getUserPermissions = (userId) => async (dispatch) => {
    try {
        dispatch({ type: USER_PERMISSIONS_REQUEST });
        
        const response = await axios.get(`/users/${userId}/permissions`);
        
        dispatch({
            type: USER_PERMISSIONS_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: USER_PERMISSIONS_FAILURE,
            payload: error.response?.data?.message || 'Failed to fetch user permissions'
        });
    }
};

// Assign permissions to user
export const assignUserPermissions = (userId, permissionIds) => async (dispatch) => {
    try {
        dispatch({ type: ASSIGN_USER_PERMISSIONS_REQUEST });
        
        const response = await axios.post(`/users/${userId}/permissions/assign`, {
            permission_ids: permissionIds
        });
        
        dispatch({
            type: ASSIGN_USER_PERMISSIONS_SUCCESS,
            payload: response.data
        });
        
        // Refresh user permissions
        dispatch(getUserPermissions(userId));
    } catch (error) {
        dispatch({
            type: ASSIGN_USER_PERMISSIONS_FAILURE,
            payload: error.response?.data?.message || 'Failed to assign permissions'
        });
    }
};

// Revoke permissions from user
export const revokeUserPermissions = (userId, permissionIds) => async (dispatch) => {
    try {
        dispatch({ type: REVOKE_USER_PERMISSIONS_REQUEST });
        
        const response = await axios.post(`/users/${userId}/permissions/revoke`, {
            permission_ids: permissionIds
        });
        
        dispatch({
            type: REVOKE_USER_PERMISSIONS_SUCCESS,
            payload: response.data
        });
        
        // Refresh user permissions
        dispatch(getUserPermissions(userId));
    } catch (error) {
        dispatch({
            type: REVOKE_USER_PERMISSIONS_FAILURE,
            payload: error.response?.data?.message || 'Failed to revoke permissions'
        });
    }
};

// Sync user permissions (replace all direct permissions)
export const syncUserPermissions = (userId, permissionIds) => async (dispatch) => {
    try {
        dispatch({ type: SYNC_USER_PERMISSIONS_REQUEST });
        
        const response = await axios.post(`/users/${userId}/permissions/sync`, {
            permission_ids: permissionIds
        });
        
        dispatch({
            type: SYNC_USER_PERMISSIONS_SUCCESS,
            payload: response.data
        });
        
        // Refresh user permissions
        dispatch(getUserPermissions(userId));
    } catch (error) {
        dispatch({
            type: SYNC_USER_PERMISSIONS_FAILURE,
            payload: error.response?.data?.message || 'Failed to sync permissions'
        });
    }
};

// Get available permissions
export const getAvailablePermissions = () => async (dispatch) => {
    try {
        dispatch({ type: AVAILABLE_PERMISSIONS_REQUEST });
        
        const response = await axios.get('/permissions/available');
        
        dispatch({
            type: AVAILABLE_PERMISSIONS_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: AVAILABLE_PERMISSIONS_FAILURE,
            payload: error.response?.data?.message || 'Failed to fetch available permissions'
        });
    }
};

// Clear user permissions state
export const clearUserPermissionsState = () => ({
    type: CLEAR_USER_PERMISSIONS_STATE
}); 